import scrollTo from '../helpers/scrollTo';
import smoothscroll from 'smoothscroll-polyfill';

export default () => {
    const hash = window.location.hash;
    const hashLink = document.querySelectorAll('a[href*="#"]');
    const hashSelect = document.querySelectorAll('option[value^="#"]');

    // smooth scroll polyfill - safari
    smoothscroll.polyfill();

    /**
     * Hash on page load
     */
    if (hash) {
        // document.addEventListener('DOMContentLoaded', (e) => {
        //     if (hash) {
        //         e.preventDefault();
        //         scrollTo(hash);
        //     }
        // });
        window.addEventListener('load', (e) => {
            if (hash) {
                e.preventDefault();
                scrollTo(hash);
            }
        });
    }

    /**
     * Hash on link click.
     */

    if (hashLink.length > 0) {
        hashLink.forEach((link) => {
            link.addEventListener('click', (event) => {
                const url = event.currentTarget.getAttribute('href');
                const parts = url.split('#');
                const path = parts[0];
                const hash = `#${parts[1]}`;

                if (path === '' || path === window.location.pathname) {
                    scrollTo(hash);
                    event.preventDefault();
                }
            });
        });
    }

    /**
     * Hash on select change.
     */
    if (hashSelect.length > 0) {
        hashSelect.forEach((option) => {
            option.parentNode.addEventListener('change', (event) => {
                const hash = event.currentTarget.value;

                scrollTo(hash);
            });
        });
    }
};
